import { createTheme } from '@mui/material'

const { breakpoints: themeBreakpoints } = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      ms: 365,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
})

export const breakpoints = themeBreakpoints
